import React, { useState } from 'react';
import axios from 'axios';

function ChangePasswordModal({ onClose }) {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const update = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const handleSave = async () => {
    if (!form.new_password) return setError('Nova lozinka je obavezna.');
    if (form.new_password.length < 8) return setError('Lozinka mora imati najmanje 8 znakova.');
    if (form.new_password !== form.confirm_password) return setError('Lozinke se ne podudaraju.');

    setLoading(true);
    setError('');
    try {
      await axios.post('/auth/change-password', {
        current_password: form.current_password,
        new_password: form.new_password,
      }, { withCredentials: true });
      setSuccess('Lozinka uspješno promijenjena!');
      setTimeout(onClose, 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Greška pri promjeni lozinke.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: 400 }}>
        <h2>Promjena lozinke</h2>

        <div className="form-group">
          <label>Trenutna lozinka</label>
          <input
            type="password"
            value={form.current_password}
            onChange={e => update('current_password', e.target.value)}
            placeholder="••••••••"
          />
        </div>

        <div className="form-group">
          <label>Nova lozinka (min. 8 znakova)</label>
          <input
            type="password"
            value={form.new_password}
            onChange={e => update('new_password', e.target.value)}
            placeholder="••••••••"
          />
        </div>

        <div className="form-group">
          <label>Potvrdi novu lozinku</label>
          <input
            type="password"
            value={form.confirm_password}
            onChange={e => update('confirm_password', e.target.value)}
            placeholder="••••••••"
            onKeyDown={e => e.key === 'Enter' && handleSave()}
          />
        </div>

        {error && <p className="error">{error}</p>}
        {success && (
          <p style={{ color: '#00b894', fontSize: 14, marginTop: 8 }}>{success}</p>
        )}

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>Odustani</button>
          <button className="btn btn-primary" onClick={handleSave} disabled={loading}>
            {loading ? 'Spremanje...' : 'Spremi lozinku'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordModal;
